import { ISalePageDetailResponse } from '@/api/types';
import { isRandomMediaProduct } from '../product/utils';

const isDigitalSalePage = <
  T extends Partial<Pick<ISalePageDetailResponse, 'type'>>,
>(
  salePage: T
) => {
  return salePage.type === 'DIGITAL';
};

export const hasRandomMediaProduct = <
  T extends Partial<Pick<ISalePageDetailResponse, 'type' | 'products'>>,
>(
  salePage: T
) => {
  return (
    isDigitalSalePage(salePage) && salePage.products?.some(isRandomMediaProduct)
  );
};
